import React from "react";
import { Switch } from "@mui/material";

interface ToggleFollowCellProps {
  checked: boolean;
  onToggle: (nextChecked: boolean) => void;
}

export const ToggleFollowCell: React.FC<ToggleFollowCellProps> = ({
  checked,
  onToggle,
}) => {
  return (
    <Switch
      checked={checked}
      onChange={(e) => onToggle(e.target.checked)}
      onClick={(e) => e.stopPropagation()}
    />
  );
};